<template>
  <div class="flex align-center justify-center flex-direction bg-white text-black" style="overflow-x: hidden">
    <homeHeader></homeHeader>
    <div class="cooperate-mask">
      <div class="cooperate-mask-opt">
        <div class="cooperate-mask-title">商务合作</div>
        <div class="cooperate-mask-title-info">
          Business Cooperation
        </div>
      </div>
      <img src="https://assets.pfotoo.com/PC/2/%E7%BC%96%E7%BB%84%208@2x.png" class="cooperate-mask-img">
    </div>
    <div class="text-500" style="font-size: 30px; margin-top: 120px; margin-bottom: 80px;">广告投放&活动推广</div>
    <div class="flex align-center flex-direction cooperate-view">
      <div class="cooperate-more flex align-center justify-center flex-direction">
        <div class="flex align-center justify-between" style="width: 100%;">
          <div class="cooperate-more-item flex flex-direction align-center justify-center" v-for="item in mores">
            <img :src="item.icon" style="width: 80px;height: 80px;">
            <div class="name">{{item.name}}</div>
            <div class="info" v-for="txt in item.info">
              {{txt}}
            </div>
          </div>
        </div>
        <div class="cooperate-more-but-view flex align-center justify-center">
          <a href="https://openai.weixin.qq.com/webapp/jDgwDGsnHz8LXBmMwbNBffXZuPqmsS?robotName=Fotoo%E5%BE%81%E9%9B%86%E4%B8%80%E4%B8%8B" target="_blank" style="text-decoration: none;">
              <div class="cooperate-more-but flex align-center justify-center">立即联系</div>
          </a>
        </div>
      </div>
      <div class="cooperate-privacy flex-direction flex align-center justify-center text-500">
        <div style="font-size: 40px;margin-bottom: 80px;">我们关注每一位用户的声音</div>
        <div style="font-size: 24px;width: 858px;">如果你在悟空投票使用或者合作中遇到难以解决的问题，以及任何对平台发展有益的意见及建议，欢迎你 添加我们的微信；</div>
        <img src="https://assets.pfotoo.com/PC/2/%E4%BD%8D%E5%9B%BE.png" style="margin-top: 80px;"/>
      </div>
    </div>
    <homeFooter></homeFooter>
  </div>
</template>

<script>
  import App from '../util/comfun'
  import homeHeader from '../pages/components/home/header.vue'
  import homeFooter from '../pages/components/home/footer.vue'
  export default {
    data () {
      return {
        mores:[
          {
            icon:'https://assets.pfotoo.com/PC/2/%E7%BC%96%E7%BB%84%202.png',
            name:'平台流量',
            info:['单日浏览量200万+','月访问300万+人次'],
          },
          {icon:'https://assets.pfotoo.com/PC/2/%E7%BC%96%E7%BB%84%203.png',name:'品牌推广',
            info:['针对适合用户群','推广你的品牌'],
          },
          {icon:'https://assets.pfotoo.com/PC/2/%E7%BC%96%E7%BB%84%205.png',name:'一键增粉',
            info:['帮你的小程序','公众号等增粉'],
          },
          {icon:'https://assets.pfotoo.com/PC/2/%E7%BC%96%E7%BB%84%206.png',name:'首页推广',
            info:['按购买天数在首页','推广你的活动'],
          },
        ]
      }
    },
    components:{
      homeHeader,
      homeFooter,
    },
    methods:{

    },
    mounted(){

    },

  }
</script>

<style>
.cooperate-mask{
  width: 100%;
  height: 750px;
  background-image: url("https://assets.pfotoo.com/PC/2/%E8%83%8C%E6%99%AF%E5%9B%BE%E5%A4%87%E4%BB%BD%204.png");
  background-size: 100% 100%;
}
.cooperate-view{
  width: 1024px;
  box-sizing: border-box;
}
  .cooperate-more{
    width: 100%;
    height: 490px;
    background: linear-gradient(331deg,#7aecdc 3%, #45d5b6 81%);
    border-radius: 10px;
    margin-bottom: 100px;
    box-sizing: border-box;
    padding: 0 50px;
    position: relative;
  }
  .cooperate-privacy{
    margin-left: 0;
    width: 100vw;
    height: 732px;
    background: #fbfbfb;
  }
  .cooperate-more-name{
    width: 160px;
    height: 46px;
    font-size: 40px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    line-height: 46px;
    margin-bottom: 100px;
  }
  .cooperate-more-item{
    width: 200px;
    height: 300px;
    background: #ffffff;
    border-radius: 10px;
  }
.cooperate-more-item .name{
  height: 46px;
  font-size: 24px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #5d5d5d;
  line-height: 46px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.cooperate-more-item .info{
  height: 30px;
  font-size: 20px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #5d5d5d;
  line-height: 30px;
}
.cooperate-mask-opt{
  margin-top: 263px;
  margin-left: 10vw;
}
  .cooperate-mask-title{
    height: 46px;
    font-size: 50px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    line-height: 46px;
  }
.cooperate-but{
  width: 300px;
  height: 90px;
  background: #3dc4a7;
  border-radius: 8px;
  margin-top: 189px;

  font-size: 28px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color: #ffffff;
}
  .cooperate-but-icon{
    width: 26px;
    height: 26px;
    background-size: 100% 100%;
    background-image: url("https://assets.pfotoo.com/PC/%E5%8F%B3%E7%AE%AD%E5%A4%B4.png");
    margin-left: 22px;
    margin-top: 5px;
  }
  .cooperate-more-but-view{
    position: absolute;
    bottom: -26px;
    left: 0;
    width: 100%;
  }
  .cooperate-more-but{
    width: 300px;
    height: 70px;
    background: #ffffff;
    border-radius: 38px;
    box-shadow: 0px 2px 4px 0px rgba(154,154,154,0.50);
    box-sizing: border-box;

    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #3dc4a7;
  }
.cooperate-mask-img{
  position: absolute;
  right:5vw;
  top:190px;
  border-radius: 10px;
  width: 600px;
  height: 397px;
}
  .cooperate-mask-title-info{
    width: 250px;
    height: 46px;
    font-size: 24px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    line-height: 46px;
    margin-top: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/cooperate.vue